import script from "./CopyrightCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyrightCenter.vue?vue&type=script&setup=true&lang=js"

import "./CopyrightCenter.vue?vue&type=style&index=0&id=158cc4e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-158cc4e2"]])

export default __exports__